export const INVENTORY_GAME = "game";
export const INVENTORY_WEB = "web";
